import React, { useEffect, createElement } from 'react';
interface PageSEOProps {
  title: string;
  description: string;
  path: string;
  ogImage?: string;
  keywords?: string;
  ogType?: string;
}
function setMetaTag(name: string, content: string, isProperty = false) {
  const attr = isProperty ? 'property' : 'name';
  let element = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attr, name);
    document.head.appendChild(element);
  }
  element.setAttribute('content', content);
}
export function PageSEO({
  title,
  description,
  path,
  ogImage,
  keywords,
  ogType
}: PageSEOProps) {
  const siteUrl = 'https://www.vitalityvf.com';
  const defaultImage = 'https://cdn.magicpatterns.com/uploads/rLCDkCKprcJW1NkEV2aCi1/Vitality_Logo_Circle.png';
  const fullUrl = `${siteUrl}${path}`;
  const image = ogImage || defaultImage;
  useEffect(() => {
    // Page title
    document.title = title;
    // Standard meta
    setMetaTag('description', description);
    setMetaTag('robots', 'index, follow');
    // Keywords (if provided)
    if (keywords) {
      setMetaTag('keywords', keywords);
    }
    // Open Graph
    setMetaTag('og:title', title, true);
    setMetaTag('og:description', description, true);
    setMetaTag('og:url', fullUrl, true);
    setMetaTag('og:image', image, true);
    setMetaTag('og:type', ogType || 'website', true);
    setMetaTag('og:site_name', 'Vitality Venture Fund', true);
    setMetaTag('og:locale', 'en_US', true);
    // Twitter Card
    setMetaTag('twitter:card', 'summary_large_image');
    setMetaTag('twitter:title', title);
    setMetaTag('twitter:description', description);
    setMetaTag('twitter:image', image);
    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);
  }, [title, description, fullUrl, image, keywords, ogType]);
  return null;
}